/**
 * Runs before any application code on the client (Next.js instrumentation).
 *
 * React 19.2's dev-build "Performance Tracks" (logComponentRender →
 * addObjectDiffToProperties) deep-diff every re-rendered component's props
 * during EVERY commit to annotate the profiler timeline. On data-heavy pages
 * (company detail passes 100+-node network graphs and >100KB financials
 * objects as props) one commit becomes minutes of synchronous diffing — the
 * tab hard-freezes. Klaro's bundled core-js makes it worse by patching
 * Function.prototype.toString, which the differ calls per function prop.
 * (Root-caused 2026-07-16 via DevTools pause: the entire stack was
 * logComponentRender/addObjectDiffToProperties inside commitPassiveMountOnFiber.)
 *
 * React enables the feature only when `console.timeStamp` and
 * `performance.measure` both exist (`supportsUserTiming`), so removing
 * console.timeStamp in dev is the supported-adjacent kill switch. Remove this
 * once React ships a real opt-out (see facebook/react issue tracker for
 * enableComponentPerformanceTrack).
 *
 * Trade-off: React's component tracks no longer appear in Chrome Performance
 * recordings during dev. Comment this out temporarily if you need them.
 */
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (console as any).timeStamp = undefined;
}

export {};
